import { useDispatch, useSelector, useStore } from 'react-redux'
import type { AppDispatch, AppStore, RootState } from './store'

/** Use throughout the app instead of plain `useDispatch` from `react-redux`. */
export const useAppDispatch = useDispatch.withTypes<AppDispatch>()

/** Use throughout the app instead of plain `useSelector` from `react-redux`. */
export const useAppSelector = useSelector.withTypes<RootState>()

/** Typed store access for rare cases (e.g. outside React). */
export const useAppStore = useStore.withTypes<AppStore>()
